// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e3BGE","buttons":"styles_buttons__zlTpG"};